module.exports = __webpack_public_path__ + "static/media/audio-call.9e595242.svg";